import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

const listNavigation = [
  // { name: "organizer", title: "Penyelenggara", path: "/event/organizer", fa: 'as fa-shield-alt mr-3' },
  // {
  //   name: "all",
  //   title: "Acara Webinar",
  //   path: "/event/all",
  //   fa: "fas fa-map-marker-alt mr-3",
  // },
  {
    name: "blog",
    title: "Berita",
    path: "/event/blog",
    fa: "fas fa-images mr-3",
  },
  {
    name: "gallery",
    title: "Kumpulan Video & Galeri",
    path: "/event/gallery",
    fa: "fas fa-video mr-3",
  },
];

export default ({ path, handleOnclick }) => {
  return (
    <section className="nav-blue">
      <div className="container">
        <ul className="nav nav-pills pills-blue">
          {listNavigation.map((e, i) => {
            return (
              <>
                <li className="nav-item" key={i+e.name}>
                  <Link
                    className={classNames("nav-link", {
                      active: path === e.name,
                    })}
                    to={e.path}
                    onClick={() => handleOnclick(e.name)}
                  >
                    <i className={e.fa}></i>
                    {e.title}
                  </Link>
                </li>
              </>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
